import React, { useState } from 'react';
import IATAModal from './modal/signUpIATAModal';
import BusinessModal from './modal/signUpBusinessModal';
import SaveModal from './modal/saveModal';
import axios from 'axios';
import Loader from './common/loader';
import GetIATAModal from './modal/signUpGetIATAModal';

function SignUp() {
    const [IsStatus, setIsStatus] = useState('BSP');
    const [IsDupliCheck, setIsDupliCheck] = useState(false);
    const [IsNull, setIsNull] = useState('');
    const [IsWait, setIsWait] = useState(false);
    const [IATACode, setIATACode] = useState(null);
    const [checkIATACode, setCheckIATACode] = useState(true);
    const [BusinessNum, setBusinessNum] = useState(null);
    const [AgencyName, setAgencyName] = useState(null);
    const [agencyId, setagencyId] = useState(null);
    const [agencyData, setagencyData] = useState([]);
    const [modalAction, setModalAction] = useState(null);
    const [modalContent, setModalContent] = useState(null);
    const [saveStatus, setSaveStatus] = useState(true);

    // 입력값
    const [email, SetEmail] = useState('');
    const [id, setId] = useState('');
    const [name, setName] = useState('');
    const [phone, setPhone] = useState('');
    const [title, setTitle] = useState('');
    const [password, SetPassword] = useState('');

    const agentStatusSelect = (e) => {
        const value = e.target.value;
        setIATACode('')
        setBusinessNum('')
        if (value === 'BSP') {
            setIsStatus('BSP');
        } else {
            setIsStatus('ATR');
        }
    };
    const receiveModalData = (data) => {
        setagencyData(data);
        setBusinessNum(data.saupNumb);
        setAgencyName(data.kornName);
    };
    // 아아디 중복체크
    const duplicateCheck = async () => {
        try {
            if (id == '') {
                setModalAction(() => () => setSaveStatus(true));
                setModalContent('아이디를 입력해주세요.');
                setSaveStatus(false);
                return false;
            }
            const hostname = window.location.hostname;
            let isLocal = null;
            if (hostname === 'localhost' || hostname === 'twpal.philippineair.co.kr') {
                isLocal = false;
            } else {
                isLocal = true;
            }

            await axios.get(
                `${
                    isLocal
                        ? process.env.REACT_APP_PRODUCTION_API_URL
                        : process.env.REACT_APP_LOCAL_API_URL
                }/wpal/${id}`,
            );

            setModalAction(() => () => setSaveStatus(true));
            setModalContent('사용가능한 아이디입니다.');
            setSaveStatus(false);
            setIsDupliCheck(true);
        } catch (error) {
            setModalAction(() => () => setSaveStatus(true));
            setModalContent(error.response.data.message);
            setSaveStatus(false);
            setId(null);
            setIsDupliCheck(false);
        }
    };

    // iataCode/사업자등록번호 검색
    const searchIATAOrBusinessNum = async (e) => {
        const status = e.target.id ?? '';

        if (status === 'iataCode') {
            // 서버 통신후 존재하지 않는다면
            try {
                if (IATACode === '') {
                    setModalAction(() => () => setSaveStatus(true));
                    setModalContent('IATACODE를 입력해주세요.');
                    setSaveStatus(false);
                    return;
                }
                const hostname = window.location.hostname;
                let isLocal = null;
                if (hostname === 'wpal.philippineair.co.kr') {
                    isLocal = true;
                } else {
                    isLocal = false;
                }
                const checkCode = await axios.get(
                    `${
                        isLocal
                            ? process.env.REACT_APP_PRODUCTION_API_URL
                            : process.env.REACT_APP_LOCAL_API_URL
                    }/wpal/signup/code?status=${status}&code=${IATACode}`,
                );
                setAgencyName(checkCode.data.kornName);
                setagencyId(checkCode.data.id);
            } catch (error) {
                setIsNull('IATA');
                setAgencyName('');
            }
        } else if (status === 'businessNum') {
            // 서버 통신후 존재하지 않는다면
            try {
                setIsWait(true);
                if (BusinessNum.length < 10) {
                    setModalAction(() => () => setSaveStatus(true));
                    setModalContent('사업자번호는 10자 입력 필수 입니다.');
                    setSaveStatus(false);
                    setIsWait(false);
                    return false;
                } else {
                    const hostname = window.location.hostname;
                    let isLocal = null;
                    if (hostname === 'wpal.philippineair.co.kr') {
                        isLocal = true;
                    } else {
                        isLocal = false;
                    }
                    const checkCode = await axios.get(
                        `${
                            isLocal
                                ? process.env.REACT_APP_PRODUCTION_API_URL
                                : process.env.REACT_APP_LOCAL_API_URL
                        }/wpal/signup/code?status=${status}&code=${BusinessNum}`,
                    );

                    setCheckIATACode(!checkCode.data.iataCode);
                    if (checkCode.data.iataCode) {
                        setIATACode(checkCode.data.iataCode);
                    }
                    setagencyData(checkCode.data);
                    setagencyId(checkCode.data.id);
                    setAgencyName(checkCode.data.kornName);
                    setIsWait(false);
                }
            } catch (error) {
                setIsWait(false);
                setIsNull('Business');
                setAgencyName('');
            }
        } else {
            setIsNull('');
        }
    };

    const saveUser = async () => {
        const formData = new FormData();

        if (IsDupliCheck) {
            if (!id) { 
                setModalAction(() => () => setSaveStatus(true));
                setModalContent('아이디를 입력해주세요.');
                setSaveStatus(false);
                return;
            } else if (!name) {
                setModalAction(() => () => setSaveStatus(true));
                setModalContent('이름을 입력해주세요.');
                setSaveStatus(false);
                return;
            } else if (!phone) {
                setModalAction(() => () => setSaveStatus(true));
                setModalContent('휴대폰 번호를 입력해주세요.');
                setSaveStatus(false);
                return;
            } else if (!email) {
                setModalAction(() => () => setSaveStatus(true));
                setModalContent('이메일을 입력해주세요.');
                setSaveStatus(false);
                return;
            } else if (!password) {
                setModalAction(() => () => setSaveStatus(true));
                setModalContent('비밀번호를 입력해주세요.');
                setSaveStatus(false);
                return;
            } else if (!AgencyName) {
                setModalAction(() => () => setSaveStatus(true));
                setModalContent('대리점 먼저 조회 후 다시 시도해주세요.');
                setSaveStatus(false);
                return;
            } else {
                formData.append('userId', id);
                formData.append('name', name);
                formData.append('title', title);
                formData.append('phone', phone);
                formData.append('email', email);
                formData.append('password', password);
                formData.append('agencyId', agencyId);

                if (checkIATACode) {
                    formData.append('iataCode', IATACode);
                }

                if (agencyData) {
                    Object.keys(agencyData).forEach((key) => {
                        if (key === 'file') {
                            formData.append('file', agencyData[key]);
                        } else if (key !== 'iataCode') {
                            formData.append(key, agencyData[key]);
                        }
                    });
                }
                try {
                    const hostname = window.location.hostname;
                    let isLocal = null;
                    if (hostname === 'localhost' || hostname === 'twpal.philippineair.co.kr') {
                        isLocal = false;
                    } else {
                        isLocal = true;
                    }

                    await axios.post(
                        `${
                            isLocal
                                ? process.env.REACT_APP_PRODUCTION_API_URL
                                : process.env.REACT_APP_LOCAL_API_URL
                        }/wpal/signup`,
                        formData,
                        {
                            headers: {
                                'Content-Type': 'multipart/form-data',
                            },
                        },
                    );

                    setModalAction(() => () => (window.location.href = '/login'));
                    setModalContent('회원가입 축하드립니다.');
                    setSaveStatus(false);
                } catch (error) {
                    setModalAction(() => () => setSaveStatus(true));
                    setModalContent(
                        '서비스에 문제가 발생하였습니다. 문제가 지속될 경우, developer@raksoholdings.com로 문의해 주시면 확인 후 답변 드리겠습니다.',
                    );
                    setSaveStatus(false);
                }
            }
        } else {
            setModalAction(() => () => setSaveStatus(true));
            setModalContent('ID 중복체크 후 다시 시도해주세요.');
            setSaveStatus(false);
            return;
        }
    };

    return (
        <>
            {IsWait && <Loader />}
            <div className='bodyContainer'>
                <div class='subp_h_wrap'>
                    <div class='subp_h_list subp_h_home'>
                        <div>회원가입</div>
                    </div>
                </div>
                <div id='contents'>
                    <div className='signUpFromWrap'>
                        <div className='page_hgroup'>
                            <h3 class='title'>회원가입</h3>
                        </div>

                        {/* 여행사 확인 */}
                        <div className='agentCheckWrap'>
                            <h4>여행사 확인</h4>

                            <table className='signUp-table'>
                                <tbody>
                                    <tr className='firstTable-border'>
                                        <th className='firstTable'>
                                            <span className='important-value'>*</span>여행사 구분
                                        </th>
                                        <td>
                                            <label className='tableRadio table-padding'>
                                                <input
                                                    type='radio'
                                                    name='travelType'
                                                    value='BSP'
                                                    onClick={agentStatusSelect}
                                                    defaultChecked
                                                />
                                                BSP
                                            </label>
                                            <label className='tableRadio table-padding'>
                                                <input
                                                    type='radio'
                                                    name='travelType'
                                                    value='ATR'
                                                    onClick={agentStatusSelect}
                                                />
                                                ATR
                                            </label>
                                        </td>
                                    </tr>
                                    <tr
                                        className={
                                            IsStatus === 'BSP' || IsStatus === '' ? '' : 'hide'
                                        }
                                    >
                                        <th>
                                            <span className='important-value'>*</span>IATA 코드
                                        </th>
                                        <td className='input-button'>
                                            <div className='table-padding'>
                                                <input
                                                    className={
                                                        checkIATACode ? '' : 'wpal-iataCode-check'
                                                    }
                                                    type='text'
                                                    id='iataCode'
                                                    placeholder='IATA CODE'
                                                    value={IATACode}
                                                    maxLength={8}
                                                    onChange={(e) =>
                                                        setIATACode(
                                                            e.target.value.replace(/[^0-9]/g, ''),
                                                        )
                                                    }
                                                />
                                            </div>
                                            <div>
                                                <input
                                                    type='button'
                                                    className={`each-button ${
                                                        IsStatus === '' ? 'hide' : ''
                                                    }`}
                                                    id='iataCode'
                                                    value={'조회'}
                                                    onClick={searchIATAOrBusinessNum}
                                                ></input>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr
                                        className={
                                            IsStatus === 'ATR' || IsStatus === '' ? '' : 'hide'
                                        }
                                    >
                                        <th>
                                            <span className='important-value'>*</span>사업자 등록
                                            번호
                                        </th>
                                        <td className='input-button'>
                                            <div className='table-padding'>
                                                <input
                                                    type='text'
                                                    id='businessRegistrationNumber'
                                                    placeholder='사업자 등록 번호'
                                                    value={BusinessNum}
                                                    maxLength={10}
                                                    minLength={10}
                                                    onChange={(e) =>
                                                        setBusinessNum(
                                                            e.target.value.replace(/[^0-9]/g, ''),
                                                        )
                                                    }
                                                />
                                            </div>
                                            <div>
                                                <input
                                                    type='button'
                                                    className='each-button'
                                                    id='businessNum'
                                                    value={'조회'}
                                                    onClick={searchIATAOrBusinessNum}
                                                ></input>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <span className='important-value'>*</span>
                                            대리점명
                                        </th>
                                        <td>
                                            <div className='table-padding'>{AgencyName}</div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        {/* 회원 정보 */}
                        <div className='agentCheckWrap'>
                            <h4>회원 정보</h4>

                            <table className='signUp-table'>
                                <tbody>
                                    <tr className='firstTable-border'>
                                        <th>
                                            <span className='important-value'>*</span>ID
                                        </th>
                                        <td className='input-button'>
                                            <div className='table-padding'>
                                                <input
                                                    type='text'
                                                    className='signUp'
                                                    id='userId'
                                                    placeholder='ID'
                                                    value={id}
                                                    onChange={(e) => setId(e.target.value)}
                                                    disabled={IsDupliCheck}
                                                />
                                            </div>
                                            <div>
                                                <input
                                                    type='button'
                                                    className='each-button'
                                                    id='businessNum'
                                                    onClick={duplicateCheck}
                                                    hidden={IsDupliCheck}
                                                    value={'중복체크'}
                                                ></input>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <span className='important-value'>*</span>이름
                                        </th>
                                        <td>
                                            <div className='table-padding'>
                                                <input
                                                    type='text'
                                                    id='userName'
                                                    placeholder='이름(10자 이내)'
                                                    value={name}
                                                    onChange={(e) => setName(e.target.value)}
                                                    maxLength={10}
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>직급</th>
                                        <td>
                                            <div className='table-padding'>
                                                <input
                                                    type='text'
                                                    id='userPosition'
                                                    placeholder='직급'
                                                    value={title}
                                                    onChange={(e) => setTitle(e.target.value)}
                                                    maxLength={10}
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <span className='important-value'>*</span>휴대폰
                                        </th>
                                        <td>
                                            <div className='table-padding'>
                                                <input
                                                    type='text'
                                                    id='userPhone'
                                                    placeholder='휴대폰'
                                                    value={phone}
                                                    maxLength={11}
                                                    onChange={(e) => setPhone(e.target.value)}
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <span className='important-value'>*</span>이메일
                                        </th>
                                        <td className='input-button'>
                                            <div className='table-padding'>
                                                <input
                                                    type='text'
                                                    id='userEmail'
                                                    placeholder='이메일'
                                                    value={email}
                                                    onChange={(e) => SetEmail(e.target.value)}
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <span className='important-value'>*</span>비밀번호
                                        </th>
                                        <td>
                                            <div className='table-padding'>
                                                <input
                                                    type='password'
                                                    id='password'
                                                    placeholder='비밀번호'
                                                    value={password}
                                                    onChange={(e) => SetPassword(e.target.value)}
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className='submitArea'>
                            <input
                                type='button'
                                className='each-button btn46 red'
                                value={'회원 가입 하기'}
                                onClick={saveUser}
                            ></input>
                        </div>
                    </div>
                </div>
                {IsNull === 'IATA' && (
                    <IATAModal
                        IsNull={IsNull}
                        onClose={() => {
                            setIsNull('');
                            setIsStatus('');
                        }}
                    />
                )}

                {IsNull === 'Business' && IATACode != '' && (
                    <GetIATAModal
                        IsNull={IsNull}
                        IsGroup={false}
                        onClose={() => setIsNull('')}
                        setModalAgencyData={receiveModalData} 
                    />
                )}

                {IsNull === 'Business'  && IATACode == '' && (
                    <BusinessModal
                        IsNull={IsNull}
                        onClose={() => setIsNull('')}
                        setModalAgencyData={receiveModalData}
                    />
                )}
                <SaveModal content={modalContent} SaveBtn={saveStatus} onClose={modalAction} />
            </div>
        </>
    );
}

export default SignUp;
